var _rect, _rect2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditProfileModal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#864629",
    fillOpacity: 0.1
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4843_28580",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 6,
    width: 20,
    height: 20
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 6,
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4843_28580)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.0003 20.5833C17.042 20.5833 17.9274 20.2187 18.6566 19.4896C19.3857 18.7604 19.7503 17.875 19.7503 16.8333C19.7503 15.7917 19.3857 14.9062 18.6566 14.1771C17.9274 13.4479 17.042 13.0833 16.0003 13.0833C14.9587 13.0833 14.0732 13.4479 13.3441 14.1771C12.6149 14.9062 12.2503 15.7917 12.2503 16.8333C12.2503 17.875 12.6149 18.7604 13.3441 19.4896C14.0732 20.2187 14.9587 20.5833 16.0003 20.5833ZM16.0003 18.9167C15.417 18.9167 14.9239 18.7153 14.5212 18.3125C14.1184 17.9097 13.917 17.4167 13.917 16.8333C13.917 16.25 14.1184 15.7569 14.5212 15.3542C14.9239 14.9514 15.417 14.75 16.0003 14.75C16.5837 14.75 17.0767 14.9514 17.4795 15.3542C17.8823 15.7569 18.0837 16.25 18.0837 16.8333C18.0837 17.4167 17.8823 17.9097 17.4795 18.3125C17.0767 18.7153 16.5837 18.9167 16.0003 18.9167ZM9.33366 23.5C8.87533 23.5 8.48296 23.3368 8.15658 23.0104C7.83019 22.684 7.66699 22.2917 7.66699 21.8333V11.8333C7.66699 11.375 7.83019 10.9826 8.15658 10.6563C8.48296 10.3299 8.87533 10.1667 9.33366 10.1667H11.9587L13.5003 8.5H18.5003L20.042 10.1667H22.667C23.1253 10.1667 23.5177 10.3299 23.8441 10.6563C24.1705 10.9826 24.3337 11.375 24.3337 11.8333V21.8333C24.3337 22.2917 24.1705 22.684 23.8441 23.0104C23.5177 23.3368 23.1253 23.5 22.667 23.5H9.33366ZM9.33366 21.8333H22.667V11.8333H19.292L17.7712 10.1667H14.2295L12.7087 11.8333H9.33366V21.8333Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditProfileModal);
export default __webpack_public_path__ + "static/media/edit-profile-modal.46094345101f0a67f521d00f24c6da13.svg";
export { ForwardRef as ReactComponent };